import React, { useRef, useEffect, useState } from "react";
import { QuoteTextContainer, MainQuoteText } from "./style";

export const AutoResizingQuoteText = ({
    children,
    height = "80%",
    verticalAlign = "center",
    textAlign = "center",
    textColor = "#000",
    textFont = "Manrope",
    fontSize: userFontSize = "15",
    minFontSize = 10,
    isQuoteScreen = false,
}) => {
    const textRef = useRef(null);
    const [fontSize, setFontSize] = useState(() => {
        return Math.max(parseInt(userFontSize) || 15, minFontSize);
    });
    
    useEffect(() => {
        const text = textRef.current;
        if (!text) return;

        let size = parseInt(userFontSize) || 15;

        const measure = () => {
            text.style.fontSize = `${size}px`;
            const containerHeight = text.parentElement?.clientHeight || 0;

            while (text.scrollHeight > containerHeight && size > minFontSize) {
                size--;
                text.style.fontSize = `${size}px`;
            }

            setFontSize(size);
        };

        const frame = requestAnimationFrame(measure);

        return () => cancelAnimationFrame(frame);
    }, [children, userFontSize, textFont, minFontSize]);


    const content = (
        <div ref={textRef}>
            {children}
        </div>
    );

    const commonProps = {
        verticalAlign,
        textAlign,
        textColor,
        textFont,
        fontSize,
    };

    if (isQuoteScreen) {
        return (
            <QuoteTextContainer {...commonProps}>
                {content}
            </QuoteTextContainer>
        );
    }

    return (
        <MainQuoteText height={height} {...commonProps}>
            {content}
        </MainQuoteText>
    );
};